// "This device is ours" (#3021). The founder household browses the live site
// signed out, and every one of those visits counted as an outside visitor in
// PostHog, GA4 and the Astra Lite records (all 14 "visitor" questions from
// Oct 1 to Oct 3 were ours: one home network, not signed in).
//
// Opening the team link (/team-device?k=<token>, minted by
// scripts/team_device_url.py) asks counselor-agent whether the token is
// genuine; only then is it stored here, in localStorage AND a first-party
// cookie, so clearing one still leaves the other. The marker is the signed
// token itself: the Astra Lite route re-verifies it on every call
// (astra_lite.team_ok) and files the conversation as source 'team', so a
// forged value in this storage changes nothing on the server.
//
// Privacy: this marks OUR devices. Nothing new is learned about a visitor;
// a browser without the marker behaves exactly as before.

export const TEAM_STORAGE_KEY = 'stratia_team_device';
export const TEAM_COOKIE = 'stratia_team_device';
// The shape mint_team_token produces: t1. + 32 url-safe base64 characters of
// an HMAC over the Astra Lite token key. Anything else is never stored.
export const TEAM_TOKEN_RE = /^t1\.[A-Za-z0-9_-]{32}$/;
const COOKIE_MAX_AGE = 400 * 24 * 3600;   // browsers cap cookie lifetime at 400 days

function readCookie() {
    try {
        const hit = document.cookie.split(';').map((c) => c.trim())
            .find((c) => c.startsWith(`${TEAM_COOKIE}=`));
        return hit ? decodeURIComponent(hit.slice(TEAM_COOKIE.length + 1)) : null;
    } catch { return null; }
}

function writeCookie(value, maxAge) {
    try {
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `${TEAM_COOKIE}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
    } catch { /* cookies blocked: localStorage still holds it */ }
}

/** The stored team token, or null. Heals whichever store lost it. */
export function teamToken() {
    let stored = null;
    try { stored = localStorage.getItem(TEAM_STORAGE_KEY); } catch { /* private mode */ }
    const cookie = readCookie();
    const token = [stored, cookie].find((t) => t && TEAM_TOKEN_RE.test(t)) || null;
    if (token) {
        if (stored !== token) { try { localStorage.setItem(TEAM_STORAGE_KEY, token); } catch { /* blocked */ } }
        if (cookie !== token) writeCookie(token, COOKIE_MAX_AGE);
    }
    return token;
}

export const isTeamDevice = () => Boolean(teamToken());

/** Store a token the server has already confirmed. */
export function markTeamDevice(token) {
    if (!TEAM_TOKEN_RE.test(String(token || ''))) return false;
    try { localStorage.setItem(TEAM_STORAGE_KEY, token); } catch { /* blocked */ }
    writeCookie(token, COOKIE_MAX_AGE);
    return true;
}

export function clearTeamDevice() {
    try { localStorage.removeItem(TEAM_STORAGE_KEY); } catch { /* blocked */ }
    writeCookie('', 0);
}
